import React from "react";
import { HOME } from "@/constants/testIds";

export const FinalCTA = () => {
  return (
    <section
      id="start"
      data-testid={HOME.finalCta}
      className="relative py-24 md:py-32 bg-ink text-[hsl(var(--ivory))] overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-[520px] w-[820px] rounded-full bg-[radial-gradient(closest-side,hsla(217,85%,48%,0.20),transparent)] pointer-events-none" />

      <div className="container-narrow relative text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-[hsla(40,33%,97%,0.15)] bg-[hsla(40,33%,97%,0.04)] px-3 py-1.5 text-[11px] font-mono uppercase tracking-[0.18em] text-[hsla(40,33%,97%,0.7)]">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald dot-pulse" />
          Live Shipment Tracking™
        </div>

        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-[64px] leading-[1.04] font-semibold text-balance max-w-3xl mx-auto">
          Never lose sight of your shipment again.
        </h2>

        <p className="mt-6 text-[15.5px] text-[hsla(40,33%,97%,0.75)] max-w-xl mx-auto leading-relaxed">
          Track every shipment, every milestone and every update inside one
          Workspace — built for serious importers.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#"
            data-testid={HOME.finalCtaPrimary}
            className="inline-flex items-center gap-2 bg-[hsl(var(--ivory))] !text-[hsl(var(--ink))] px-5 py-3 rounded-xl text-[14px] font-medium hover:bg-white transition-colors hover:translate-y-[-1px]"
          >
            Start Tracking
            <span aria-hidden>→</span>
          </a>
          <a
            href="#"
            data-testid={HOME.finalCtaSecondary}
            className="inline-flex items-center gap-2 border border-[hsla(40,33%,97%,0.20)] text-[hsl(var(--ivory))] px-5 py-3 rounded-xl text-[14px] font-medium hover:bg-[hsla(40,33%,97%,0.06)] transition-colors"
          >
            Create your free Workspace
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 text-[11px] font-mono uppercase tracking-[0.18em] text-[hsla(40,33%,97%,0.55)]">
          <span>Live Visibility</span>
          <span className="h-1 w-1 rounded-full bg-[hsla(40,33%,97%,0.3)]" />
          <span>Connected Operations</span>
          <span className="h-1 w-1 rounded-full bg-[hsla(40,33%,97%,0.3)]" />
          <span>No Product Markups</span>
        </div>
      </div>
    </section>
  );
};
